// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background-color: rgba(0, 0, 0, 0.5); /* arka plan karartma */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  
  .popup-box {
    background: #fff;
    padding: 2.5rem 2rem;
    border-radius: 16px;
    text-align: center;
    box-shadow: 0 0 20px rgba(0,0,0,0.3);
  }
  
  .popup-box h2 {
    margin-bottom: 1.5rem;
    font-size: 1.5rem;
  }
  
  .premise-btn,
  .cloud-btn {
    margin: 0.5rem;
    padding: 0.75rem 2rem;
    font-size: 1rem;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    transition: background 0.2s ease;
  }
  
  .premise-btn {
    background-color: #741c25;
    color: white;
  }
  .premise-btn:hover {
    background-color: #5b151c;
  }
  
  .cloud-btn {
    background-color: #356583;
    color: white;
  }
  .cloud-btn:hover {
    background-color: #274c61;
  }
  `, "",{"version":3,"sources":["webpack://./src/styles/PremiseOrCloud.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,YAAY;IACZ,oCAAoC,EAAE,uBAAuB;IAC7D,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,oCAAoC;EACtC;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;;IAEE,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;EACA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;EACA;IACE,yBAAyB;EAC3B","sourcesContent":[".overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100vh;\n    width: 100vw;\n    background-color: rgba(0, 0, 0, 0.5); /* arka plan karartma */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n  }\n  \n  .popup-box {\n    background: #fff;\n    padding: 2.5rem 2rem;\n    border-radius: 16px;\n    text-align: center;\n    box-shadow: 0 0 20px rgba(0,0,0,0.3);\n  }\n  \n  .popup-box h2 {\n    margin-bottom: 1.5rem;\n    font-size: 1.5rem;\n  }\n  \n  .premise-btn,\n  .cloud-btn {\n    margin: 0.5rem;\n    padding: 0.75rem 2rem;\n    font-size: 1rem;\n    border: none;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: background 0.2s ease;\n  }\n  \n  .premise-btn {\n    background-color: #741c25;\n    color: white;\n  }\n  .premise-btn:hover {\n    background-color: #5b151c;\n  }\n  \n  .cloud-btn {\n    background-color: #356583;\n    color: white;\n  }\n  .cloud-btn:hover {\n    background-color: #274c61;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
